import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ClientPortalWebNarrativeModel } from "services/api/cplapi/CPLAPI";
import { IWebNarrativesService } from "services/WebNarrativesService";
import { RootState } from "setup";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

type WebNarrativesInitialState = {
  WebNarratives: Array<ClientPortalWebNarrativeModel>;
  Updating: boolean;
  Loading: boolean;
};

const initialState: WebNarrativesInitialState = {
  WebNarratives: new Array<ClientPortalWebNarrativeModel>(),
  Updating: false,
  Loading: false,
};

export const webNarrativesSlice = createSlice({
  name: "WebNarratives",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getWebNarratives.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getWebNarratives.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getWebNarratives.fulfilled, (state, action) => {
        state.WebNarratives = action.payload;
        state.Loading = false;
      })
      .addCase(updateWebNarrative.pending, (state) => {
        state.Updating = true;
      })
      .addCase(updateWebNarrative.rejected, (state) => {
        state.Updating = false;
      })
      .addCase(updateWebNarrative.fulfilled, (state) => {
        state.Updating = false;
      });
  },
});

export const getWebNarratives = createAsyncThunk("WebNarratives/GetWebNarratives", async () => {
  const webNarrativesService = container.get<IWebNarrativesService>(SERVICE_TYPES.WebNarrativesService);
  return await webNarrativesService.getWebNarratives();
});

export const updateWebNarrative = createAsyncThunk(
  "WebNarratives/UpdateWebNarrative",
  async (webNarrative: ClientPortalWebNarrativeModel, thunkAPI) => {
    const webNarrativesService = container.get<IWebNarrativesService>(SERVICE_TYPES.WebNarrativesService);
    await webNarrativesService.updateWebNarrative(webNarrative);
    thunkAPI.dispatch(getWebNarratives());
  }
);

export const selectLoading = (state: RootState) => state.webNarratives.Loading;
export const selectUpdating = (state: RootState) => state.webNarratives.Updating;
export const selectWebNarratives = (state: RootState) => state.webNarratives.WebNarratives;

export default webNarrativesSlice.reducer;
